import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 7 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m2.175 5.652 4.1-4.1a.875.875 0 0 0 0-1.276.875.875 0 0 0-1.284.008L.25 5.027a.9.9 0 0 0-.25.63q0 .18.062.338a.8.8 0 0 0 .188.282l4.742 4.743q.283.284.633.27a.9.9 0 0 0 .625-.288.875.875 0 0 0 0-1.276z"
    }, null, -1)
  ]))]))
}
export default { render: render }